import {observable} from "mobx";
import http from '../../libs/http';

class Store {
  @observable records = [];
  @observable stores = [];
  @observable record = {};
  @observable analysis = {};
  @observable isFetching = false;
  @observable formVisible = false;
  @observable topFetching = false;

  @observable f_name;
  @observable f_active;
  @observable f_role;

  fetchRecords = () => {
    this.isFetching = true;
    http.get('/api/wx/')
      .then(res => this.records = res)
      .finally(() => this.isFetching = false)
  };

  fetchStores = () => {
    http.get('/api/store/')
      .then(res => this.stores = res)
  };

  fetchAnalysis = () => {
    this.topFetching = true;
    http.get('/api/wx/analysis/')
      .then(res => this.analysis = res)
      .finally(() => this.topFetching = false)
  };

  showForm = (info = {}) => {
    this.formVisible = true;
    this.record = info
  }
}

export default new Store()